const KEY = 'priiPendingAction';

/**
 * Stash an action the user wants to perform after authenticating.
 * Supported types:
 * - rsvp_going: requires eventId
 * - join_group_chat: requires groupId; inviteCode (optional) so the join goes through the link, not a request
 */
export function stashPendingAction({ type, eventId, groupId, inviteCode } = {}) {
  if (!type) return;
  const payload = { type, stashedAt: Date.now() };
  if (type === 'rsvp_going') {
    if (!eventId) return;
    payload.eventId = eventId;
  } else if (type === 'join_group_chat') {
    if (!groupId) return;
    payload.groupId = groupId;
    if (inviteCode) payload.inviteCode = inviteCode;
  } else {
    return;
  }
  try {
    sessionStorage.setItem(KEY, JSON.stringify(payload));
  } catch (e) {
    // sessionStorage can throw in private browsing / quota — fail silently
  }
}

export function readPendingAction() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    // Reject anything older than 30 minutes — guards against ancient stashes
    if (!parsed.stashedAt || Date.now() - parsed.stashedAt > 30 * 60 * 1000) {
      clearPendingAction();
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearPendingAction() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {}
}
